import React from 'react';
import styled from '@emotion/styled';
import Box from '@mui/material/Box';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

// Styled components
const DateContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderRadius: `10px`,
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper,
}));

const CustomDatePicker = styled(ReactDatePicker)(({ theme }) => ({
    border: `0px solid`,
    borderRadius: `3px`,
    padding: theme.spacing(1),
    fontSize: '1rem',
    width: '100%',
    textAlign: 'center',
    '&:focus': {
        borderColor: theme.palette.primary.main,
    },
}));

// DatePicker Component
const DatePicker = ({ onChange, selected, dateFormat = "dd/MM/yyyy", ...props }) => (
    <Box mt={2} mb={1} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <DateContainer>
            <CustomDatePicker
                selected={selected}
                onChange={(date) => onChange(date)}
                dateFormat={dateFormat}
                showPopperArrow={false}
                {...props}
            />
        </DateContainer>
    </Box>
);

export default DatePicker;
